import { useEffect } from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import UserPromoCodeUsageData from "./user-promo-code-usage-data";
import UserPromoCodeUsageForm from "./user-promo-code-usage-form";
import ET3PageDiv from "../../../core/et3-page-div";

const UserPromoCodeUsage = withLiteObserverAndTheme(() => {
  useEffect(() => {
    getCoreHistoryStore().setPageName(
      "USER_PROMO_CODE_USAGE",
      "USER_PROMO_CODE_USAGE"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("USER")}
        subTitle={i18n.get("PROMO_CODE_USAGE")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <UserPromoCodeUsageForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <UserPromoCodeUsageData />
    </ET3PageDiv>
  );
});
export default UserPromoCodeUsage;
